import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const Marker = styled.span `
  font-size: 0.8em;
  vertical-align: middle;
  white-space: nowrap;
  color: ${({ theme, $informative, $positive, $warning, $negative }) => {
    if ($informative)
        return theme.colors.link120_1;
    if ($positive)
        return theme.colors.positive100;
    if ($warning)
        return theme.colors.warning100;
    if ($negative)
        return theme.colors.critical100;
    return theme.colors.black_1;
}};
`;
const _OptionMarkedLabel = ({ option, informative, positive, warning, negative, marker }) => {
    if ((negative ? !option?.active : option?.active) || informative || positive || warning) {
        return (_jsxs(Wrapper, { children: [_jsx("span", { children: option?.label }), _jsx(Marker, { "$informative": informative, "$positive": positive, "$warning": warning, "$negative": negative, children: marker })] }));
    }
    return option?.label;
};
export const OptionMarkedLabel = React.memo(_OptionMarkedLabel);
